
import { Action, Getter } from 'vuex-class'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { confirmRecieve } from '@/api/shopOrder'
import { updateOrderStatus, updateOrderPayStatus, backOrder } from '@/api/order'
import AppendixName from '@/components/AppendixName/index.vue'
import StepTemp from '@/components/StepTemp/index.vue'
import {
  GoodsListOfCategoryFormatDto,
  SelectGoodsOptionsDto
} from '@/api/commonConfig'
import {
  getStoreReturnOrderDtl,
  getStoreOrderNodeList,
  getStoreOrderCanReturn,
  cancelStoreReturnOrder
} from '@/api/industryMall'
import { backToBefore, backHomes } from '@/utils/h5ToApp'
import { toNumber } from 'lodash'
import Clipboard from 'clipboard'
import goodsListPopup from '../template/goodsListPopup.vue'

@Component({
  name: 'OrderMallDetail',
  components: {
    AppendixName,
    StepTemp,
    goodsListPopup
  },
  filters: {
    filterDisWay(val: number) {
      const ways = [
        { id: 1, value: '送货上门' },
        { id: 2, value: '客户自提' },
        { id: 3, value: '商家配送' },
        { id: 4, value: '骑手配送' },
        { id: 5, value: '其他' }
      ]
      let desc = ways.find((item) => item.id === val)
      return desc ? desc.value : '--'
    }
  }
})
export default class OrderMallDetail extends Vue {
  @Getter companyId!: string
  @Getter selectList!: SelectGoodsOptionsDto[]
  @Action setSelectList!: (val: SelectGoodsOptionsDto[]) => void
  @Action setOrderFromPage!: (val: string) => void

  showPopover = false

  // 订单信息对象
  returnOrderInfo: { [x: string]: any } = {
    // 初始值
    // payFreight: 0,
    // orderTotalMoney: 0
  }
  // 退单编号
  returnOrderId = ''
  currRouteId = ''
  // 是否初始化获取数据完成
  isInit = false
  // 是否修改订单信息对象
  isUpdateOrderInfo = false
  // 进度条数据
  stepList: any[] = []
  params: {
    returnOrderId?: string
    // customerId?: string
    // companyId?: string
    // shopId?: string
    // currRouteId?: string
  } = {}
  isEdit = false
  isEditOrder = false // 是否是修改订单状态
  fromPage = '' // fromPage=='1'的时候，说明是原生跳转过来的，此时，返回按钮需要调用原生返回方法

  selectGoodsList: GoodsListOfCategoryFormatDto[] = []

  @Watch('returnOrderInfo', { deep: true, immediate: true })
  onOrderInfoChange(newVal, oldVal) {
    if (this.isInit) {
      this.isUpdateOrderInfo = true
    }
  }

  @Watch('orderInfo.payFreight', { deep: true, immediate: true })
  payFreightChange(val: string) {
    // this.orderInfo.orderMoney = Number(
    //   math.mathAdd(this.orderInfo.orderTotalMoney, val)
    // )
  }

  created() {
    // let query = this.$route.query
    this.returnOrderId = this.$route.query.returnOrderId as string
    this.params.returnOrderId = this.returnOrderId
    console.log('this.params', this.params)
    // 获取订单详情信息
    this.getInfo()
  }

  activated() {
    // if (this.$route.query.fromPath === '2') {
    //   this.orderInfo.orderTotalMoney = Number(
    //     this.$route.query.totalPrice as string
    //   )
    //   this.orderInfo.orderTotalMoney = Number(
    //     this.$route.query.totalPrice as string
    //   )
    //   this.orderInfo.orderMoney = Number(
    //     math.mathAdd(this.orderInfo.orderTotalMoney, this.orderInfo.payFreight)
    //   )
    //   this.selectGoodsList = this.selectList
    // }
    // this.fromPage = this.$route.query.fromPage
    //   ? (this.$route.query.fromPage as string)
    //   : '0'
    // if (this.fromPage === '1') this.setOrderFromPage('1')
  }

  /**
   * @description 客户取消退单
   * @param returnOrderId
   */
  cancelOrder(returnOrderId: string) {
    cancelStoreReturnOrder({ returnOrderId }).then((res) => {
      // console.log('cancelStoreReturnOrder',res)
      this.$toast('取消退货成功')
      this.getInfo()
    })
  }

  /**
   * 确认收货
   */
  confirmOrder() {
    confirmRecieve(this.params)
      .then((res) => {
        let msg = ''
        if (res.code === '000000') {
          msg = '确认收货成功'
        } else if (res.code === '000002') {
          msg = '订货单状态已变更'
        }
        this.$dialog
          .alert({
            message: msg
          })
          .then(() => {
            this.getInfo()
          })
      })
      .catch(() => {})
  }

  /* 取消订单 */
  // cancelOrder() {
  //   cancelOrderApi(this.params).then((res) => {
  //     let msg = ''
  //     if (res.code === '000000') {
  //       msg = '取消订单成功'
  //     } else if (res.code === '000002') {
  //       msg = '订货单状态已变更，不可取消订单'
  //     }
  //     this.$dialog
  //       .alert({
  //         message: msg
  //       })
  //       .then(() => {
  //         this.getInfo()
  //       })
  //   })
  // }

  handleBack() {
    if (this.fromPage === '1') {
      backToBefore()
    } else {
      this.$router.back()
    }
  }

  /**
   * @description: 监听复制
   * @param {*} e 复制内容
   * @return {*}
   */
  copyCode(key) {
    let clipboard = new Clipboard('.copy', {
      text: (trigger) => key
    })
    clipboard.on('success', (e) => {
      this.$toast('复制成功')
    })
    clipboard.on('error', (e) => {
      this.$toast('该浏览器不支持复制')
      e.clearSelection()
    })
  }

  toLog() {
    this.$router.push({
      path: '/mallLog',
      query: {
        storeId: this.returnOrderInfo.storeId,
        orderId: this.returnOrderInfo.returnOrderId,
        isReturn: '1'
      }
    })
  }

  /**
   * @description: 操作方法
   * @param {*操作类型：1：订单审核2：出库确认3：发货确认6：作废7：删除8：付款确认 9:退回} operateType
   * @param {*操作对象} obj
   * @return {*}
   */
  handleOperation(operateType) {
    let title
    let message
    let isRequired // 备注是否必填
    let isNumberInput // 确认收付款改为number输入框判断是否显示number输入框
    switch (operateType) {
      case 1:
        title = '订单审核'
        message = '是否确认订单审核通过？'
        isRequired = false
        isNumberInput = false
        break
      case 2:
        title = '出库确认'
        message = '是否确认出库？'
        isRequired = false
        isNumberInput = false
        break
      case 3:
        title = '发货确认'
        message = '是否确认发货？'
        isRequired = false
        isNumberInput = false
        break
      case 6:
        title = '作废确认'
        message = '是否确认作废订单？'
        isRequired = true
        isNumberInput = false
        break
      case 8:
        title = '确认收款'
        message = '是否确认订单收款完成？'
        isRequired = false
        isNumberInput = true
        break
      case 9:
        title = '退回确认'
        message = '是否确认退回订单重新审核？'
        isRequired = true
        isNumberInput = false
        break
    }
    ;(this.$refs.handleFlow as any).show({
      title,
      message,
      operateType,
      isRequired,
      isNumberInput
    })
  }

  /**
   * @description: 修改订货单状态方法
   * @param {*请求参数} params
   * @param {*提示} tips
   * @return {*}
   */
  updateOrderStatus(params, successTips) {
    updateOrderStatus(params).then((res) => {
      this.$toast({
        type: 'success',
        message: `${successTips}`,
        duration: 1000,
        onClose: () => {
          // 刷新订单信息对象
          this.reloadInfo()
        }
      })
    })
  }

  /**
   * @description: 修改订货单付款状态方法
   * @param {*请求参数} params
   * @param {*提示} tips
   * @return {*}
   */
  updateOrderPayStatus(params, successTips) {
    updateOrderPayStatus(params).then((res) => {
      this.$toast({
        type: 'success',
        message: `${successTips}`,
        duration: 1000,
        onClose: () => {
          // 刷新订单信息对象
          this.reloadInfo()
        }
      })
    })
  }

  handleFlowConfirm({ remark, operateType }) {
    // 成功提示
    let successTips
    switch (operateType) {
      case 1:
        successTips = '订单审核通过'
        break
      case 2:
        successTips = '订单出库成功'
        break
      case 3:
        successTips = '订单发货成功'
        break
      case 6:
        successTips = '订单作废成功'
        break
      case 8:
        successTips = '确认付款完成'
        break
      case 9:
        successTips = '退回成功'
        break
    }
    // 处理获取请求参数
    let query = this.$route.query
    if (operateType === 9) {
      // 退回
      let params = {
        companyId: this.companyId,
        orderId: query.orderId,
        currRouteId: query.currRouteId,
        Remark: remark
      }
      backOrder(params).then((res) => {
        this.$toast({
          type: 'success',
          message: `${successTips}`,
          duration: 1000,
          onClose: () => {
            // 刷新订单信息对象shouhuo
            this.reloadInfo()
          }
        })
      })
    } else if (operateType === 8) {
      let params = {
        companyId: this.companyId,
        currRouteId: query.currRouteId,
        orderId: query.orderId,
        orderType: 1,
        money: toNumber(remark)
      }
      this.updateOrderPayStatus(params, successTips)
    } else {
      let orderIdList = [
        {
          currRouteId: query.currRouteId,
          orderId: query.orderId
        }
      ]
      let params = {
        companyId: this.companyId,
        operateType,
        orderIdList,
        orderRemark: remark
      }
      this.updateOrderStatus(params, successTips)
    }
    this.reloadInfo()
  }

  /**
   * @description: 获取进度条数据
   * @param {*}
   * @return {*}
   */
  getStepList() {
    let params = {
      orderId: this.returnOrderInfo.orderId,
      // currRouteId: this.orderInfo.currRouteId
      // currRouteId: '1'
      // 订货传：storeOrderNode 退货传：storeReturnOrderNode
      type: 'storeReturnOrderNode'
    }
    // getOrderOrReturnNodeList(params).then((res) => {
    getStoreOrderNodeList(params).then((res) => {
      const list = res.data || []
      this.stepList = list.map((item: any) => {
        return {
          key: item.nodeId,
          title: item.nodeName.replace('【客户】', '') // 将'【客户】'去掉，避免title过长
          // isValid: item.isValid
        }
      })
    })
  }

  /**
   * @description: 获取订单详情信息
   * @param {*}
   * @return {*}
   */
  getInfo() {
    this.isInit = false
    this.isUpdateOrderInfo = false
    // 采购单
    // getOrderInfo(this.params).then((res) => {
    getStoreReturnOrderDtl(this.params).then((res) => {
      // this.orderInfo = res.data
      // this.params.orderId = this.orderInfo.orderId
      // this.params.customerId = this.companyId
      // this.params.companyId = this.companyId
      // this.params.shopId = res.data.shopCompanyId
      // this.params.currRouteId = res.data.currRouteId
      // console.log(123, this.params)
      // this.selectGoodsList = res.data.orderDtlList.map((item) => {
      //   return {
      //     goodsId: item.goodsId,
      //     goodsName: item.goodsName,
      //     imageNameUrl: item.packageMainImage,
      //     versionId: item.versionId,
      //     saleAmount: item.saleAmount,
      //     orderPrice: item.salePrice,
      //     packageId: item.setmealId,
      //     maximum: item.maximum,
      //     minimum: item.minimum,
      //     // packageName: item.packageName,
      //     packageNameDesc: item.packageNameDesc
      //   }
      // })
      // this.setSelectList(this.selectGoodsList)
      // // 获取进度条数据

      this.$nextTick(() => {
        this.isInit = true
      })
      console.log('res', res)
      this.returnOrderInfo = res.data[0]
      this.selectGoodsList = res.data[0].del
      this.getStepList()
    })
  }

  // 刷新订单信息对象
  reloadInfo() {
    window.sessionStorage.setItem('isRefresh', '1')
    this.getInfo()
  }
  /**
   * 格式化金额 仅可录入数字，最少为0.00，最大为99999999.99
   * @param value
   */
  formatterMoney(value) {
    if (value) {
      value = Number(value) > 99999999.99 ? '99999999.99' : value
    } else {
      value = '0'
    }
    return value
      .replace(/0*(\d+)/, '$1')
      .replace(/[^0-9.]/g, '')
      .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
  }

  editAmount() {
    this.isEdit = true
    this.$nextTick(() => {
      ;(this.$refs.payFreight as any).focus()
    })
  }
  showGoodsList () {
    (this.$refs.goodsList as any).showPop(this.returnOrderInfo)
  }
}
